// noinspection JSUnresolvedReference,JSUnusedGlobalSymbols

(function(app) {
	app.Utils = {
		priority: 100,

		priceCalculationController: null,
		priceCache: {},
		debouncedCalculatePriceAjax: null,

		init() {
			this.debouncedCalculatePriceAjax = this.debounce(this.calculatePriceAjax.bind(this), 100);
			
			// Set up price display updates
			this.setupPriceDisplay();
		},
		
		/**
		 * Set up price display updates when store state changes
		 */
		setupPriceDisplay() {
			// Subscribe to price changes in the store
			app.Store.subscribe('price', (priceData) => {
				this.updatePriceDisplay(priceData);
			});
			
			// Subscribe to loading state changes
			app.Store.subscribe('isCalculatingPrice', (isLoading) => {
				this.updateLoadingState(isLoading);
			});
		},
		
		/**
		 * Update the price display elements with new price data
		 * @param {object} priceData - The price data from the server
		 */
		updatePriceDisplay(priceData) {
			console.log('updatePriceDisplay called with:', priceData);
			if (!priceData || !priceData.success) {
				console.log('Price data invalid or unsuccessful');
				return;
			}
			
			const currentPriceEl = document.querySelector('.wdatca-current-price');
			const pricePerUnitEl = document.querySelector('.wdatca-current-price-per-unit');
			const variationPrice = document.querySelector('.woocommerce-variation-price');
			
			console.log('Price elements found:', {
				currentPriceEl: !!currentPriceEl,
				pricePerUnitEl: !!pricePerUnitEl
			});
			
			if (currentPriceEl && priceData.fullPriceFormatted) {
				console.log('Updating current price to:', priceData.fullPriceFormatted);
				currentPriceEl.textContent = priceData.fullPriceFormatted;
			}
			
			if (pricePerUnitEl && priceData.unitPriceFormatted) {
				console.log('Updating unit price to:', priceData.unitPriceFormatted);
				pricePerUnitEl.textContent = priceData.unitPriceFormatted + ' pr. stk.';
			}
		},
		
		/**
		 * Update the loading state of price elements
		 * @param {boolean} isLoading - Whether the price is being calculated
		 */
		updateLoadingState(isLoading) {
			const priceWrapper = document.querySelector('.wdatca-price-wrapper');
			if (!priceWrapper) return;
			
			if (isLoading) {
				priceWrapper.classList.add('is-loading');
			} else {
				priceWrapper.classList.remove('is-loading');
			}
		},

		/**
		 * Debounce a function, but call immediately if not already waiting.
		 * @param {function} func - The function to debounce
		 * @param {number} wait - The wait time in milliseconds
		 * @returns {function} - The debounced function
		 */
		debounce(func, wait) {
			let timeout;
			return function executedFunction(...args) {
				const later = () => {
					clearTimeout(timeout);
					func.apply(this, args);
				};
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
			};
		},

		/**
		 * Calculate the price of the product via AJAX with caching
		 * @returns {Promise} - Promise with the price data
		 */
		calculatePriceAjax() {
			console.log('calculatePriceAjax called');
			return new Promise((resolve, reject) => {
				if (this.priceCalculationController) {
					this.priceCalculationController.abort();
				}

				this.priceCalculationController = new AbortController();

				const priceData = app.collectPriceData();
				console.log('Price data to send:', priceData);
				const cacheKey = JSON.stringify(priceData);

				// Check cache first
				if (this.priceCache[cacheKey]) {
					console.log('Using cached price data');
					app.Store.setState('isCalculatingPrice', false);
					app.Store.setState('price', this.priceCache[cacheKey]);
					return;
				}

				app.Store.setState('isCalculatingPrice', true);

				const data = new FormData();
				data.append('action', 'calculate_price');
				data.append('security', window.priceNonce);
				// Use variation ID if available, otherwise use main product ID
				const productId = app.Store.getState('variationId') || app.Store.getState('productId') || window.productId;
				console.log('Using product ID for calculation:', productId);
				data.append('productId', productId);
				data.append('priceData', JSON.stringify(priceData));

				// console.log('Price data:', priceData);
				
				fetch(window.ajaxurl, /** @type {RequestInit} */ {
					method: 'POST',
					body: data,
					signal: this.priceCalculationController.signal
				})
				.then(response => response.json())
				.then(data => {
					console.log('Price calculation response:', data);
					if (data.success) {
						this.priceCache[cacheKey] = data.data;
						app.Store.setState('price', data.data);
						resolve(data.data);
					} else {
						console.error('Price calculation failed:', data.message);
						reject(new Error(data.message || 'Price calculation failed'));
					}
					app.Store.setState('isCalculatingPrice', false);
				})
				.catch(reject => {
					console.error('Price calculation error:', reject);
					if (reject.name !== 'AbortError') {
						app.Store.setState('isCalculatingPrice', false);
					}
				})
				.finally(() => {
					// app.Store.setState('isCalculatingPrice', false);
				});
			});
		},

		/**
		 * Format a number as Danish currency
		 * @param {number} price - The price to format
		 * @returns {string} - The formatted price string
		 */
		formatPrice(price) {
			if (typeof price !== 'number' || isNaN(price)) {
				return '0,00';
			}

			return new Intl.NumberFormat('da-DK', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
				useGrouping: true
			}).format(price);
		},

		/**
		 * Clamp a value between a minimum and maximum
		 * @param {number|string} value - The value to clamp
		 * @param {number} min - The minimum value
		 * @param {number} max - The maximum value
		 * @returns {number} - The clamped value
		 */
		clampValue(value, min, max) {
			return Math.min(Math.max(parseFloat(value) || min, min), max);
		},

		// /**
		//  * Format a number to a string
		//  * @param {number|string} value - The value to format
		//  * @returns {string} - The formatted value
		//  */
		// formatNumber(value) {
		// 	const num = parseFloat(value);
		// 	if (isNaN(num)) {
		// 		return '0';
		// 	}

		// 	return Number.isInteger(num) ? num.toString() : num.toFixed(2);
		// },

		/**
		 * Format a number to a string using Danish formatting
		 * @param {number|string} value - The value to format
		 * @returns {string} - The formatted value with Danish decimal separators
		 */
		formatNumber(value) {
			const num = parseFloat(value);
			if (isNaN(num)) {
				return '0';
			}

			if (Number.isInteger(num)) {
				return num.toString();
			}

			// Use Danish formatting with comma as decimal separator
			return new Intl.NumberFormat('da-DK', {
				minimumFractionDigits: 0,
				maximumFractionDigits: 1,
				useGrouping: false
			}).format(num);
		},

		/**
		 * Get the percentage of a value in a range
		 * @param {number} value - The value to get the percentage of
		 * @param {number} min - The minimum value
		 * @param {number} max - The maximum value
		 * @returns {number} - The percentage of the value
		 */
		getPercentageInRange(value, min, max) {
			value = Math.max(min, Math.min(max, value));
			return (value - min) / (max - min);
		},

		/**
		 * Get the aspect ratio of a width and height
		 * @param {number} width - The width to calculate the aspect ratio for
		 * @param {number} height - The height to calculate the aspect ratio for
		 * @returns {number} - The calculated aspect ratio
		 */
		getAspectRatio(width, height) {
			if (width === 0 || height === 0) {
				return 1;
			}

			return width / height;
		},

		/**
		 * Get the closest discount
		 * @param {number} quantity - The quantity of the product
		 * @returns {number} - The index of the closest discount
		 */
		getClosestDiscount(quantity) {
			let bestMatchIndex = 0;
			let bestMatchQty = 0;

			window.productDiscountData.forEach((data, index) => {
				const discountQty = parseInt(data.quantity);
				if (discountQty <= quantity && discountQty > bestMatchQty) {
					bestMatchIndex = index;
					bestMatchQty = discountQty;
				}
			});

			return bestMatchIndex;
		},

		/**
		 * Validate required DOM elements and report missing ones
		 * @param {string} componentName - Name of the component for error messaging
		 * @param {Object} elementChecks - Object mapping element names to their selectors/elements
		 * @returns {boolean} - True if all elements are present, false if any are missing
		 */
		validateElements(componentName, elementChecks) {
			const missingElements = [];

			Object.entries(elementChecks).forEach(([elementName, elementOrSelector]) => {
				let element;
				
				if (typeof elementOrSelector === 'string') {
					// It's a selector string
					element = elementOrSelector.includes('querySelectorAll') 
						? document.querySelectorAll(elementOrSelector.replace('querySelectorAll:', ''))
						: document.querySelector(elementOrSelector);
				} else {
					// It's already an element or NodeList
					element = elementOrSelector;
				}

				// Check if element exists
				if (!element || (element.length !== undefined && element.length === 0)) {
					const selector = typeof elementOrSelector === 'string' 
						? elementOrSelector.replace('querySelectorAll:', '')
						: '[element reference]';
					missingElements.push(`${elementName} (${selector})`);
				}
			});

			if (missingElements.length > 0) {
				console.warn(`Missing required ${componentName}: ${missingElements.join(', ')}`);
				return false;
			}

			return true;
		},
	};
})(window.app = window.app || {});

/**
 * Always round up to `decimals` places,
 * ignoring tiny floating‑point errors.
 *
 * @param {number} decimals Number of digits after the decimal.
 * @returns {number}        The ceil‑rounded string.
 */
Number.prototype.toFixedCeil = function(decimals = 0) {
	const num = Number(this);
	if (!Number.isFinite(num)) {
		throw new TypeError(`Invalid number: ${this}`);
	}

	const prec = Number(decimals);
	if (!Number.isInteger(prec) || prec < 0) {
		throw new TypeError(`Invalid decimals: ${decimals}`);
	}

	const factor = 10 ** prec;
	const scaled = num * factor;
	const eps = Number.EPSILON * Math.abs(scaled);
	const adjusted = scaled - eps;
	const rounded = Math.ceil(adjusted) / factor;

	const stripped = rounded
		.toFixed(prec)
		.replace(/\.?0+$/, '');

	return Number(stripped);
}

Math.clamp = function(value, min, max) {
	return Math.min(Math.max(value, min), max);
}